module.exports = __webpack_public_path__ + "5eec395f4b391809ee5f96eaf68924de.png";